'use client'
import Field from './FormBlock.Field.client'
import styles from './FormBlock.module.scss'
import { useState } from 'react'
import RadioGroup from '@/src/components/common/RadioGroup'

export default function WorkWithUsFormFields() {
  const [workerInfo, setWorkerInfo] = useState<string>('')
  const [workerReq, setWorkerReq] = useState<string>('')

  return (
    <>
      <Field
        required
        label={'First name'}
        input={
          <input
            name={'First_Name'}
            type={'text'}
            placeholder={'First name'}
            required
            autoComplete={'off'}
          />
        }
        className={styles.half}
      />
      <Field
        label={'Last name'}
        input={<input name={'Last_Name'} type={'text'} placeholder={'Last name'} />}
        className={styles.half}
      />
      <Field
        required
        label={'Email address'}
        input={<input name={'Email'} type={'email'} placeholder={'Email address'} />}
        className={styles.full}
      />
      <Field
        label={'Mobile phone'}
        input={
          <input
            name={'Mobile_Phone'}
            type={'phone'}
            placeholder={'Mobile phone'}
            pattern="(0)(4|5)[0-9]{8}"
            minLength={10}
            maxLength={10}
          />
        }
        className={styles.half}
      />
      <Field
        label={'Landline Phone'}
        input={
          <input
            name={'Landline_Phone'}
            type={'phone'}
            placeholder={'Landline Phone'}
            pattern="(0)(2|3|7|8)[0-9]{8}"
            minLength={10}
            maxLength={10}
          />
        }
        className={styles.half}
      />
      <Field
        required
        label={'I am a...'}
        labelAsDiv
        input={
          <RadioGroup
            onChange={value => {
              setWorkerInfo(value as string)
            }}
            name={'Worker_Info'}
            options={['Independent Worker', 'Organisation']}
          />
        }
        className={styles.full}
      />
      <Field
        required
        label={'I am looking for...'}
        labelAsDiv
        input={
          <RadioGroup
            onChange={value => {
              setWorkerReq(value as string)
            }}
            name={'Worker_Requirement'}
            options={['Information', 'Work Opportunities']}
          />
        }
        className={styles.full}
      />
      {(() => {
        switch (`${workerReq}|${workerInfo}`) {
          case 'Information|Independent Worker':
          case 'Information|Organisation':
            return (
              <Field
                required
                label={'Comments'}
                input={<textarea name={'Comments'} placeholder={'Comments'} />}
                className={styles.full}
              />
            )
          case `Work Opportunities|Organisation`:
          case `Work Opportunities|Independent Worker`:
            return (
              <>
                {workerInfo === 'Organisation' && (
                  <>
                    <Field
                      required
                      label={'Company name'}
                      input={
                        <input type={'text'} name={'Worker_Company'} placeholder={'Company name'} />
                      }
                      className={styles.full}
                    />
                    <Field
                      required
                      label={'ABN'}
                      input={<input type={'text'} name={'Worker_ABN'} placeholder={'ABN'} />}
                      className={styles.full}
                    />
                  </>
                )}
                <Field
                  required
                  label={'Service(s) you can provide'}
                  input={<textarea name={'Worker_Service'} placeholder={'Service(s)'} />}
                  className={styles.full}
                />
                <Field
                  required
                  label={'Location(s) you can service'}
                  input={<textarea name={'Worker_Location'} placeholder={'Location(s)'} />}
                  className={styles.full}
                />
                {workerInfo === 'Independent Worker' && (
                  <Field
                    required
                    label={'Upload your resume'}
                    input={<input type={'file'} name={'Worker_Resume'} />}
                    className={styles.full}
                  />
                )}
              </>
            )
        }
        return null
      })()}
    </>
  )
}
